<template>
  <div id="app">
    <div class="sticky">
      <div class="row">
        <div class="col col-sm justify-content-center">
          <!-- <div class="alert alert-danger" role="alert"> <b>Herbst-Rabatt- / TFP-Aktion! </b> 50% Rabatt auf Alles, außer auf Event-Kategorie! Interesse an TFP? Bitte nehmen Sie mit mir <router-link
                    to="/kontakt"
                    class="alert-link">
              <a>Kontakt</a> </router-link> auf!  Gültig bis 30.11.2020
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div> -->
          <img src="./assets/WernickeLogo.png" alt=""  class="" :style="{width:65+'%'}">
        </div>

      </div>
      <Navbar></Navbar>
    </div>
    <router-view/>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
export default {
  name: 'App',
  components: {
    Navbar,
  }
}
</script>

<style lang="scss">
  @import "~bootstrap/scss/bootstrap";
#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  }
  .sticky {
    position: -webkit-sticky;
    position: sticky;
    padding-top: 15px;
    top: 0px;
    z-index: 1000;
    background: white;
  }
  body {
    overflow-y: scroll;
    overflow-x: hidden;
  }
</style>
